import React, { useEffect, useState } from "react";
import { Calendar } from "antd";
import moment from "moment";
import events from "../../Assets/events";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { connect } from "react-redux";
import { addTimesheet, getTimesheets, updateTimesheet } from "../../Services/TimeSheet/action";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "../../Assets/Css/Holiday.scss";

moment.locale("en-GB");

function TimeSheetCalender(props) {
  const [inData, setInData] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchData();
  }, [location.search]);

  const fetchData = async () => {
    try {
      await props?.getTimesheets();
    } catch (error) {
      console.error("Error fetching timesheet:", error);
    }
  };

  useEffect(() => {
    if (props?.timesheet?.length) {
      updateCalendarData(props?.timesheet);
    }
  }, [props?.timesheet]);


  const updateCalendarData = (data) => {
    setLoading(true);

    const mappedData = data
      ?.filter((item) => {
        const userTimerMatch = item?.task?.taskTimerMap?.find(
          (timer) =>
            timer?.employee_id === props?.user?.id &&
            timer?.start_time?.split(" ")[0] === item?.start_date?.split(" ")[0]
        );
        return userTimerMatch;
      })
      ?.map((item) => ({
        id: item?.id,
        date: moment(item?.start_date?.split(" ")[0]).format("DD-MM-YYYY"),
        memo: item?.memo,
        allData: { ...item },
      }));

    setInData(mappedData);
    setLoading(false);
  };

  const dateCellRender = (value) => {
    const date = value.format("DD-MM-YYYY");
    const tasks = inData.filter((entry) => entry.date === date);

    if (tasks.length > 0) {
      return (
        <div className="holiday-marker">
          {tasks.map((task) => (
            <div
              key={task.id}
              className="holiday-occasion"
              style={{ cursor: "pointer", color: "#5757fe", fontSize: "12px" }}
              onClick={() =>
                navigate("/timelogs/view", {
                  state: { data: task, from: location.pathname },
                })
              }
            >
              {task.memo}
            </div>
          ))}
        </div>
      );
    }

    return null;
  };

  return (
    <div className="App">

      <div className="holiday-calendar">
        {props.loading || loading ? (
          <Skeleton className="rounded-2" width="100%" height="100vh" />
        ) : (
          <Calendar
            mode="month"
            dateCellRender={dateCellRender}
            fullscreen={true}
          />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    loading: state.timesheetReducer.loading,
    timesheet: state.timesheetReducer.timesheet,
    user: state.authenticationReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTimesheets: () => {
      dispatch(getTimesheets());
    },
    addTimesheet: (data) => {
      dispatch(addTimesheet(data));
    },
    updateTimesheet: (id, data) => {
      dispatch(updateTimesheet(id, data));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TimeSheetCalender)
